import { useMediaQuery } from "@mui/material";

/**
 * Reactive replacement for the IS_MOBILE_DISPLAY constant.
 *
 * IS_MOBILE_DISPLAY is evaluated once at module load and never updates on
 * resize/rotate. Components that need to re-render when the viewport
 * crosses the 768px threshold should call this hook instead.
 *
 * Threshold mirrors IS_MOBILE_DISPLAY so behavior is consistent across the
 * codebase as components are migrated.
 */
export default function useIsMobile() {
  return useMediaQuery("(max-width: 767px)");
}
